import { ParamKeyValuePair, SearchParamsChange } from 'interfaces/SearchParams';

export class SearchParamsHelper {
    public static createSearchParams(init: SearchParamsChange = '') {
        return new URLSearchParams(
            typeof init === 'string' || Array.isArray(init) || init instanceof URLSearchParams
                ? init
                : Object.keys(init).reduce((memo, key) => {
                      const value = init[key] as string[];
                      return memo.concat(
                          Array.isArray(value) ? value.map((v) => [key, v]) : [[key, value]],
                      );
                  }, [] as ParamKeyValuePair[]),
        );
    }

    public static getSearchParamsForLocation(
        locationSearch: string,
        defaultSearchParams: URLSearchParams | null,
    ) {
        const searchParams = this.createSearchParams(locationSearch);

        if (defaultSearchParams) {
            defaultSearchParams.forEach((_, key) => {
                if (!searchParams.has(key)) {
                    defaultSearchParams.getAll(key).forEach((value) => {
                        searchParams.append(key, value);
                    });
                }
            });
        }

        return searchParams;
    }
}
